var map = {
  "./amex.svg": "48795",
  "./applePay.svg": "92999",
  "./blik.svg": "17588",
  "./dana.svg": "87781",
  "./footer/americanExpress.svg": "71561",
  "./footer/applePay.svg": "78195",
  "./footer/blik.svg": "80230",
  "./footer/dana.svg": "62547",
  "./footer/gcash.svg": "43300",
  "./footer/googlePay.svg": "93803",
  "./footer/ideal.svg": "28841",
  "./footer/mc.svg": "83002",
  "./footer/me.svg": "5260",
  "./footer/mp.svg": "37381",
  "./footer/ox.svg": "90529",
  "./footer/paypal.svg": "25804",
  "./footer/pix.svg": "33204",
  "./footer/sepa_direct_debit.svg": "34334",
  "./footer/visa.svg": "33852",
  "./gcash.svg": "32278",
  "./googlePay.svg": "21847",
  "./ideal.svg": "43196",
  "./maestro.svg": "60271",
  "./mc.svg": "14091",
  "./me.svg": "24279",
  "./mp.svg": "26742",
  "./ox.svg": "46109",
  "./paypal.svg": "63012",
  "./pix.svg": "70094",
  "./safe-and-secure.svg": "48954",
  "./sepa_direct_debit.svg": "38515",
  "./visa.svg": "7575"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93282;
